import { CheckoutForm } from "@/components/cart/checkout-form";

export function CheckoutPage() {
  return <CheckoutForm />;
}
